import template from './chart-dropdown-filter.html';

class ChartDropdownFilterComponentViewModel{
	constructor (params)
	{
		this.params = params;

		this.include_dropdowns = ko.observable(params.include_dropdowns || false);
		this.reload = ko_helper.safe_observable(params.reload);

		//types
		this.dropdown_params = ko_helper.safe_observable(params.dropdown_params || ''); 
		this.selected_dropdown_value = ko_helper.safe_observable(params.selected_dropdown_value);
		this.dropdown_list = ko_helper.safe_observableArray(params.dropdown_list);
	}

	reload_filters()
	{
		this.reload(Date.now());
	}
}

export default {
	name: 'chart-dropdown-filter',
	viewModel: ChartDropdownFilterComponentViewModel,
	module_type: 'ko',
	template: template
}
